import React, { FunctionComponent } from "react"
import Loader from "src/components/common/Loader"
import "./RoleAssignmentSplash.css"


const RoleAssignmentSplash: FunctionComponent<{}> = () => {
    return (
        <div className="RoleAssignmentSplash">
            <span className="material-icons">admin_panel_settings</span>
            <Loader />
        </div>
    )
}

export default RoleAssignmentSplash